import { Copy, Crosshair, Maximize2, Minus, Plus, Redo2, RotateCw, Sparkles, Trash2, Undo2, Wand2 } from "lucide-react";

function Tool({ icon: Icon, label, onClick, disabled, testid }) {
    return (
        <button type="button" onClick={onClick} disabled={disabled} data-testid={testid} title={label}
            className="inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-[11px] font-bold text-zinc-700 transition-colors hover:bg-zinc-100 disabled:opacity-30 disabled:hover:bg-transparent">
            <Icon size={13} /> {label}
        </button>
    );
}

const Sep = () => <span className="mx-0.5 h-5 w-px bg-zinc-200" />;

/** Floats over the sheet: nesting tools, the picked image's tools, undo/redo and zoom. */
export default function SheetToolbar({ sheet, zoom, setZoom }) {
    const sel = sheet.selected;
    return (
        <div className="absolute left-4 right-4 top-4 z-20 flex flex-wrap items-center gap-1 rounded-2xl border border-zinc-200 bg-white/95 p-1.5 shadow-lg backdrop-blur" data-testid="sheet-toolbar">
            <Tool icon={Wand2} label="Auto build" onClick={sheet.tidy} disabled={!sheet.items.length} testid="tool-auto-build" />
            <Tool icon={Sparkles} label="Auto fill" onClick={() => sheet.fillFrom(sel)} disabled={!sel} testid="tool-auto-fill" />
            <Sep />
            <Tool icon={RotateCw} label="Rotate" onClick={() => sheet.rotateItem(sel)} disabled={!sel} testid="tool-rotate" />
            <Tool icon={Copy} label="Duplicate" onClick={() => sheet.duplicateItem(sel)} disabled={!sel} testid="tool-duplicate" />
            <Tool icon={Crosshair} label="Center" onClick={() => sheet.centerItem(sel)} disabled={!sel} testid="tool-center" />
            <Tool icon={Trash2} label="Delete" onClick={() => sheet.removeItem(sel)} disabled={!sel} testid="tool-delete" />
            <Sep />
            <Tool icon={Undo2} label="Undo" onClick={sheet.undo} disabled={!sheet.canUndo} testid="tool-undo" />
            <Tool icon={Redo2} label="Redo" onClick={sheet.redo} disabled={!sheet.canRedo} testid="tool-redo" />
            <div className="ml-auto flex items-center gap-0.5">
                <Tool icon={Minus} label="" onClick={() => setZoom(Math.max(0.4, +(zoom - 0.25).toFixed(2)))} testid="zoom-out" />
                <span className="w-12 text-center font-mono text-[11px] text-zinc-500" data-testid="zoom-level">{Math.round(zoom * 100)}%</span>
                <Tool icon={Plus} label="" onClick={() => setZoom(Math.min(6, +(zoom + 0.25).toFixed(2)))} testid="zoom-in" />
                <Tool icon={Maximize2} label="Fit" onClick={() => setZoom(1)} testid="zoom-fit" />
            </div>
        </div>
    );
}
